import React, { useEffect, useRef, useState } from "react";
import GIF_IMAGE from "../../../assets/img/new.gif";
import axios from "axios";
import { Col, Row } from "react-bootstrap";
import { ServiceUrl } from "../../../utils/serviceUrl";
import { _GET_PAGE } from "../../../models/fieldSettings";

const SliderText = (props) => {
  const [loader, setLoader] = useState(false);
  const [dataView, setDataView] = useState([]);
  const [dataList, setDataList] = useState([]);
  const marqueeRef = useRef();

  const field = (fieldName) => props?.dataSource?.[fieldName];

  console.log("props", props.dataSource);
  console.log("bgColor", field("bgColor") && field("bgColor"));

  useEffect(() => {
    loadPage();
  }, []);

  const loadPage = () => {
    setLoader(true);
    _GET_PAGE(field("pageId")).then((res) => {
      if (res.status == "1") {
        setDataView(res.data);
      }
      setLoader(false);
    });
  };

  const pageField = (fieldName) => dataList[fieldName] || "";

  useEffect(() => {
    listData();
  }, []);

  const listData = () => {
    setLoader(true);
    axios
      .get(ServiceUrl.LIST_PAGES + "?type=announcement&upcoming=1&top_scroll=1")
      .then((res) => {
        if (res["data"].status == "1") {
          setDataList(res["data"].data);
        }
        setLoader(false);
      });
  };

  const marqueeMouseOver = () => {
    document.getElementById("adm_top_marquee__2").stop();
  };

  const marqueeMouseOut = () => {
    document.getElementById("adm_top_marquee__2").start();
  };

  return (
    <section
      className="p-0"
      style={{
        maxHeight: "40px",
        overflow: "hidden",
        backgroundColor: field("bgColor") && field("bgColor"),
      }}
    >
      <div className="container-fluid">
        <marquee
          className="text-white"
          onMouseOver={(e) => marqueeMouseOver()}
          onMouseOut={(e) => marqueeMouseOut()}
          id="adm_top_marquee__2"
        >
          <div className="d-flex">
            {dataList.map((item, i) => {
              return (
                <span
                  style={{
                    color: "#000",
                    fontWeight: "700",
                    display: "flex",
                    paddingTop: "2px",
                  }}
                >
                  {item.show_new_blink_img == "1" && (
                    <img src={GIF_IMAGE} style={{ width: "55px" }} />
                  )}
                  {item.seo_slug && item.seo_slug.length > 4 ? (
                    <a
                      href={item.seo_slug}
                      target="_blank"
                      style={{ color: "#000" }}
                    >
                      {item.title}
                    </a>
                  ) : (
                    item.title
                  )}
                  {item.show_new_blink_img == "1" && (
                    <img src={GIF_IMAGE} style={{ width: "55px" }} />
                  )}
                </span>
              );
            })}
          </div>
        </marquee>
      </div>
    </section>
  );
};

export default SliderText;
